export default "__VITE_ASSET__9ea39bda__"